import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import isMobile from 'ismobilejs';

export const monoStyle = 'cklubq40e06ej17ojtb4pg2o1';
export const satelliteStyle = 'cknpikbkn0jut17nwxfi4mbh8';

const PreviewButton = (props) => {
  const newStyle =
    props.mapStyle === satelliteStyle ? monoStyle : satelliteStyle;
  return (
    <div
      className='m-3'
      style={{
        position: 'absolute',
        bottom: 0,
        right: 0
      }}
    >
      {' '}
      <ButtonGroup>
        <Button
          onClick={() => props.setMapStyle(monoStyle)}
          variant={props.mapStyle === monoStyle ? 'secondary' : 'light'}
        >
          Map View
        </Button>
        <Button
          onClick={() => props.setMapStyle(satelliteStyle)}
          variant={props.mapStyle === satelliteStyle ? 'secondary' : 'light'}
        >
          Satellite View
        </Button>
      </ButtonGroup>
      {/* {isMobile(window.navigator).any ? (
      ) : (
        <Button
          variant='secondary'
          className='p-0'
          onClick={() => props.setMapStyle(newStyle)}
        >
          <img
            alt='satellite-style'
            src={`https://api.mapbox.com/styles/v1/hortplus/${newStyle}/static/172.7749,-41.1388,2.55,0,0/150x150?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}&attribution=false&logo=false`}
          />
        </Button>
      )} */}
    </div>
  );
};

export default PreviewButton;
